module.exports = __webpack_public_path__ + "img/social-sim.5e443224.png";